// @flow
import api from 'common/services/api';
import type { Role } from '../../../types/Data';
import RadioUser from '../../../domain/RadioUser';

class UserManagementAPI {

  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async inviteUser(callSign: string, token: string, user: RadioUser): Promise<*> {
    const url = `/statsradio/users/${callSign}?email=${user.email}`;

    const roleReferences = user.roles.map((role: Role) => role.reference);
    const userObject = user.toObject();
    const data = { ...userObject, roles: roleReferences };

    return await api.post(url, data, { headers: this.buildHeaders(token) });
  }

  async fetchUsersForStation(callSign: string, token: string): Promise<Array<RadioUser>> {
    const url = `/statsradio/users/${callSign}`;
    const { data } = await api.get(url, {}, { headers: this.buildHeaders(token) });

    return data;
  }

  async fetchPermittedRoles(callSign: string, token: string): Promise<Array<Role>> {
    const url = `/statsradio/users/${callSign}/subordinates`;
    const { data } = await api.get(url, {}, { headers: this.buildHeaders(token) });

    return data;
  }

  async updateUserRoles(callSign: string, token: string, user: RadioUser, roles: Array<Role>): Promise<*> {
    const url = `/statsradio/users/${callSign}`;
    const body = {
      emailAddress: user.email,
      roles: roles.map((role: Role) => role.reference),
    };

    const { data } = await api.put(url, body, { headers: this.buildHeaders(token) });

    return data;
  }

  async deleteUser(callSign: string, token: string, user: Object): Promise<*> {
    const url = `/statsradio/users/${callSign}/?email=${user.email}`;

    return await api.del(url, { headers: this.buildHeaders(token) });
  }
}


export default new UserManagementAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/userManagement/services/UserManagementAPI.js